import styled from 'styled-components';
import color from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const BannerBackground = styled.div`
    height: 100%;
    background-color: ${color.softDark};
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 5px;

    img {
        width: 80%;
        margin-bottom: 30px;
        @media screen and (min-width: 1919px) {
            width: 80%;
        }
    }

    @media screen and (max-width: ${ScreenSize.tablet}px) {
        background-image: none;
        height: auto;
        margin-bottom: 30px;
    }
`;

export const Banner = styled.div`
    position: relative;
    padding: 40px 33px 10px 33px;
    border-radius: 5px;
    @media screen and (min-width: 1919px) {
        background-size: auto;
        background-position: top right;
        padding: 60px 33px 10px 33px;
    }
`;

export const Title = styled.h1`
    font-size: 28px;
    line-height: 30px;
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-weight: 600;
    color: ${color.light};
    margin-bottom: 9px;
    letter-spacing: 0;
    position: relative;
    line-height: 42px;

    @media screen and (min-width: 1919px) {
        font-size: 28px;
        margin-bottom: 10px;
        line-height: 40px;
    }
`;

export const Text = styled.em`
    display: block;
    font-style: normal;
    font-size: 24px;
    line-height: 35px;
    font-family: Poppins, Heltica, Arial, sans-serif;
    color: ${color.light};
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 25px;
    }
    @media screen and (min-width: 1919px) {
        font-size: 24px;
    }
`;
